import { registerScalar } from '@adornis/baseql/metadata/register.js';
import { GraphQLString } from 'graphql';

export class Phone {
  static _class = 'Phone';

  isPhone = true;
}

registerScalar({
  name: 'Phone',
  scalar: GraphQLString,
  coerceValue: value => String(value),
  type: Phone,
});
